import React from 'react';
import { Mutation } from 'react-apollo';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import RemoveGenericCreativeModal from 'components/RemoveGenericCreativeModal';
import { DEFAULT_VERIFICATION_DEADLINE_MINIMAL_FRAGMENT } from '../getCampaign';

const MUTATION = gql`
  mutation DeleteCreativeFileTemplate($input: CreativeFileInput!) {
    deleteCreativeFileTemplate(input: $input) {
      defaultVerificationDeadline {
        ...DefaultVerificationDeadlineMinimalFragment
        creativeFileTemplates {
          id
        }
      }
    }
  }
  ${DEFAULT_VERIFICATION_DEADLINE_MINIMAL_FRAGMENT}
`;

const RemoveCreativeFileTemplateModal = ({
  creativeFileTemplate,
  toggleClassName,
}) => (
  <Mutation mutation={MUTATION}>
    {(mutate) => (
      <RemoveGenericCreativeModal
        creativeType="file"
        id={creativeFileTemplate.id}
        name={creativeFileTemplate.name}
        remove={() =>
          mutate({
            variables: {
              input: { id: Number(creativeFileTemplate.id) },
            },
          })
        }
        toggleClassName={toggleClassName}
      />
    )}
  </Mutation>
);

RemoveCreativeFileTemplateModal.propTypes = {
  creativeFileTemplate: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  }).isRequired,
  toggleClassName: PropTypes.string,
};

RemoveCreativeFileTemplateModal.defaultProps = {
  toggleClassName: 'btn btn-link text-danger p-0 ml-auto',
};

export default RemoveCreativeFileTemplateModal;
